class Filters {
  constructor() {
    this.filters = {
      tags: [],
      stages: [],
    };

    this.fillComponent();
    document.addEventListener('programmingSlideChange', this.fillComponent.bind(this));
  }

  fillComponent() {
    this.container = document.querySelector('.container.is-active');

    if (!this.container) {
      return;
    }

    this.filters = {
      tags: [],
      stages: [],
    };

    this.stages = this.container.querySelectorAll('[data-stage]');
    this.tags = this.container.querySelectorAll('[data-tag]');
    this.clears = document.querySelectorAll('[data-action="clear-filter"]');

    Array.prototype.forEach.call(this.stages, (stage) => {
      stage.addEventListener('click', this.onClickStage.bind(this));
    });

    Array.prototype.forEach.call(this.tags, (tag) => {
      tag.addEventListener('click', this.onClickTag.bind(this));
    });

    Array.prototype.forEach.call(this.clears, (clear) => {
      clear.addEventListener('click', this.clearFilters.bind(this));
    });
  }

  onClickStage(e) {
    const input = e.target;
    const color = input.checked ? input.dataset.color : '#FFF';
    input.style.background = color;

    this.handleFilter('stages', input, input.dataset.stage);
  }

  onClickTag(e) {
    this.handleFilter('tags', e.target, e.target.dataset.tag);
  }

  handleFilter(type, input, value) {
    if (input.checked) {
      this.addFilter(type, value);
    } else {
      this.removeFilter(type, value);
    }

    this.applyFilters();
  }

  addFilter(type, value) {
    this.filters[type].push(value);
  }

  removeFilter(type, value) {
    const index = this.filters[type].indexOf(value);
    if (index !== -1) {
      this.filters[type].splice(index, 1);
    }
  }

  clearFilters() {
    Array.prototype.forEach.call(this.tags, (tag) => {
      if (tag.checked) {
        tag.click();
      }
    });

    Array.prototype.forEach.call(this.stages, (stage) => {
      if (stage.checked) {
        stage.click();
      }
    });
  }

  applyFilters() {
    const items = this.container.querySelectorAll('.speakers-item');
    const emptyTags = this.filters.tags.length === 0;
    const emptyStages = this.filters.stages.length === 0;
    const emptyFilters = emptyTags && emptyStages;

    items.forEach((item) => {
      const newItem = item;
      newItem.style.display = emptyFilters ? 'block' : 'none';
      return newItem;
    });

    if (!emptyFilters) {
      Array.prototype.forEach.call(items, (item) => {
        const newItem = item;
        let showStage = false;
        let showTag = false;
        this.filters.stages.some((stage) => {
          if (JSON.parse(item.dataset.filterStages).includes(stage)) {
            showStage = true;
          }
          return stage;
        });

        this.filters.tags.some((tag) => {
          if (JSON.parse(item.dataset.filterTags).includes(tag)) {
            showTag = true;
          }
          return tag;
        });

        if (emptyTags) {
          showTag = true;
        }

        if (emptyStages) {
          showStage = true;
        }

        newItem.style.display = showStage && showTag ? 'block' : 'none';
        return newItem;
      });
    }

    this.handleContainerVisibility(emptyFilters);
  }

  handleContainerVisibility(emptyFilters) {
    const wrapper = this.container.querySelectorAll('.programming-item');

    Array.prototype.forEach.call(wrapper, (container) => {
      const newContainer = container;
      if (emptyFilters) {
        newContainer.style.display = '';
        return true;
      }

      const items = newContainer.querySelectorAll('.speakers-item');
      let count = 0;
      const containerSize = items.length;

      Array.prototype.forEach.call(items, (item) => {
        if (item.style.display === 'none') {
          count += 1;
        }
      });

      if (count !== 0 && count === containerSize) {
        newContainer.style.display = 'none';
      } else {
        newContainer.style.display = '';
      }

      return newContainer;
    });
  }
}

export default new Filters();
